module.exports = __webpack_public_path__ + "static/media/gastronomy-kitchen-restaurant-svgrepo-com.fd22918b.svg";